module.exports = __webpack_public_path__ + "static/media/css3-logo.5f8c79d4.webp";